<template>
    <ul v-if="invites.length">
        <li v-for="invite in invites" :key="invite.key()" class="mt-2 -mx-2">
            <button @click="$modals.open('remote-invite-show-modal', { invite })" class="w-full text-left flex items-start text-sm text-gray-500 hover:bg-gray-200 rounded-md p-2">
                <i
                    class="fas fa-fw flex-shrink-0 text-sm mr-1.5 mt-1"
                    :class="invite.revoked ? 'fa-user-alt-slash text-red-300' : 'fa-paper-plane text-gray-400'"
                ></i>
                <div class="flex-1 space-y-0.5 break-all">
                    <p>{{ invite.invited_by }} invited:</p>
                    <p><strong>{{ invite.email }}</strong></p>
                    <ui-dropdown-date :moment="invite.emailed_at_moment" menu-class="p-3 w-52" #default="{ open, close, dateAgo }">
                        <p class="inline-block" @mouseenter="open" @mouseleave="close">{{ dateAgo }}</p>
                    </ui-dropdown-date>
                    <remote-invite-status :invite="invite"></remote-invite-status>
                </div>
            </button>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        invites: {
            type: Array,
            required: true,
        },
    },
}
</script>
